module.exports = __webpack_public_path__ + "img/498-13ba08.png";